import React, { Component } from "react";
import MedicalConsentHeader from "../../components/medicalconsent/MedicalConsentHeader";
import DisplayValidationErrors from "../../components/shared/DisplayValidationErrors";
import TextInput from "../../components/shared/form/TextInput";
import { Link } from "react-router-dom";
import Store from "../../content/Store";
import Content from "../../content/Content";
import Button from "../shared/buttons/Button";

export default class PrepareConsent extends Component {
  constructor(props) {
    super(props);
    this.onBack = this.onBack.bind(this);
  }

  onBack(event) {
    this.props.goBack(event);
  }

  render() {
    return (
      <React.Fragment>
        <MedicalConsentHeader
          pageTitle={this.props.pageTitle}
          pageBody={this.props.pageBody}
        />
        <DisplayValidationErrors
          heading={this.props.errorValidationHeading}
          errors={this.props.errors}
        />

        <form onSubmit={this.props.prepareConsentOnSubmit}>
          <TextInput
            hasError={this.props.prepareConsentHasError}
            inputId={this.props.inputId}
            label={this.props.prepareConsentInputLabel}
            onChange={this.props.prepareConsentOnInputFieldChange}
            inputValue={this.props.medicalConsent.claimNumber}
            autoComplete={this.props.autoComplete}
            tooltipContent={
              <Content
                name={Store.MedicalConsent.MedicalConsentClaimInput.Tooltip}
              />
            }
            gradientClass="secondary"
          />

          <div className="row my-5">
            <div className="col-sm-6 back-button">
              <p className="axa-body-text-4 mt-2">
                <Link id="backButton" to="" onClick={this.onBack}>
                  <span className="mr-2 left-arrow-back">←</span>{" "}
                  {this.props.buttonBackText}
                </Link>
              </p>
            </div>
            <div className="col-sm-6 text-right" id="submitPrepareContent">
              <Button label={this.props.nextButton} />
            </div>
          </div>
        </form>
      </React.Fragment>
    );
  }
}
